module.exports = __webpack_public_path__ + "static/mouse-right.5db5361a88f3c44b8771a7ef81945c43.svg";